import React from 'react';
import { Search } from 'lucide-react';
import './index.scss';

const SearchBar = ({
    value = '',
    onChange,
    placeholder = 'Search...',
    className = ''
}) => {
    return (
        <div className={`search-bar ${className}`}>
            {/* <Search size={18} className="search-icon" /> */}
            <input
                type="text"
                value={value}
                onChange={(e) => onChange && onChange(e.target.value)}
                placeholder={placeholder}
                className="search-input"
            />
        </div>
    );
};

export default SearchBar;
